import React from "react";
import { FileSpreadsheet } from "lucide-react";

import { DateHelper, TimeSeries } from "../../../common/src";
import { exportToXlsx } from "../../../components/src/common/exportToXlsx";
import { TimeSeriesLines } from "../../../components/src/charts/TimeSeriesLines";
import { seriesFromTimeSeries } from "../../../components/src/charts/chartTheme";

const SERIES_COLORS = ["#66BC6B", "#BDBDBD", "#B3E5FC", "#1F5F32", "#757575", "#01579B", "#AB47BC", "#4A148C"];

type PerformanceTimeSeriesChartInput = {
    timeseries: TimeSeries[];
    style?: React.CSSProperties | undefined;
    showXlsxButton?: boolean;
};

export const PerformanceTimeSeriesChart = ({
    timeseries,
    showXlsxButton = false,
    style
}: PerformanceTimeSeriesChartInput): React.ReactElement => {
    const series = timeseries.map((ts, index) => seriesFromTimeSeries(ts.normalize(1).add(-1), SERIES_COLORS[index % SERIES_COLORS.length]));
    let max = 0;
    for (const item of series) {
        for (const point of item.points) max = Math.max(max, Math.abs(point.value));
    }

    return (
        <div>
            {showXlsxButton ? (
                <div
                    style={{ width: "20px", height: "20px", marginBottom: "0.5rem" }}
                    onClick={() => {
                        const data: Record<string, Record<string, string | number>> = {};
                        timeseries.forEach((timeSeries) => {
                            for (const index in timeSeries.__dates) {
                                const date = DateHelper.timestampToString(timeSeries.__dates[index]);
                                const value = timeSeries.__values[index];
                                if (data[date]) {
                                    data[date][timeSeries.name] = value;
                                } else {
                                    const timeSeriesItem: Record<string, string | number> = {};
                                    timeSeriesItem["Date"] = date;
                                    timeSeriesItem[timeSeries.name] = value;
                                    data[date] = timeSeriesItem;
                                }
                            }
                        });
                        exportToXlsx([Object.values(data)], "performance.xlsx", ["performance"]);
                    }}
                >
                    <FileSpreadsheet className="Excel" />
                </div>
            ) : null}
            <div className="chart-print" style={style}>
                <TimeSeriesLines
                    series={series}
                    yFormat={(value) => (value * 100).toFixed(max < 0.06 ? 1 : 0) + "%"}
                    showLegend
                    ariaLabel="Performance"
                    height={360}
                    style={{ width: "100%", height: "100%" }}
                />
            </div>
        </div>
    );
};
